import { render, staticRenderFns } from "./createstateAdmin.vue?vue&type=template&id=03d8dc23&scoped=true&"
import script from "./createstateAdmin.vue?vue&type=script&lang=js&"
export * from "./createstateAdmin.vue?vue&type=script&lang=js&"
import style0 from "./createstateAdmin.vue?vue&type=style&index=0&id=03d8dc23&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d8dc23",
  null
  
)

export default component.exports